export default "__VITE_ASSET__DLMZrZIV__"